import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import login from '../views/login'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    id: 1, // 与后端一级菜单id对应
    path: '/',
    component: Layout,
    redirect: '/Machine',
    children: [
      {
        path: 'Machine',
        name: 'Machine',
        component: () => import('@/views/machine/index'),
        meta: { title: 'Machine' }
      }
    ]
  },
  {
    id: 2, // 与后端一级菜单id对应
    path: '/',
    component: Layout,
    redirect: '/Warning',
    children: [
      {
        path: 'Warning',
        name: 'Warning',
        component: () => import('@/views/warning/index'),
        meta: { title: 'Warning' }
      }
    ]
  },
  {
    id: 3, // 与后端一级菜单id对应
    path: '/',
    component: Layout,
    redirect: '/Set',
    children: [
      {
        path: 'Set',
        name: 'Set',
        component: () => import('@/views/set/index'),
        meta: { title: 'Set' }
      }
    ]
  },
  {
    id: 4, // 与后端一级菜单id对应
    path: '/',
    component: Layout,
    redirect: '/Tab',
    children: [
      {
        path: 'Tab',
        name: 'Tab',
        component: () => import('@/views/machine/tab/index'),
        meta: { title: 'Tab' }
      }
    ]
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
